var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"id":_vm.id,"src":_vm.url,"frameborder":"0","width":"100%","height":_vm.height,"scrolling":"auto"}})
}
var staticRenderFns = []

export { render, staticRenderFns }